import React, { Component } from "react";
import { Table, TableRow, TableHeader, TableBody } from "grommet";
import styled from "styled-components";
import TaskItemNameValuePair from "./TaskItemNameValuePair";

const TaskItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;
export class TaskItemListRow extends Component {
  state = { subTaskInstance: {}, urlsLoaded: false };

  componentDidMount = () => {
    //this.getUrls();
  };

  render() {
    const takePhotoInstances = this.props.subTaskInstance.TakePhotoInstances;

    return (
      <Table alignSelf="center">
        <TableHeader>
          {/* {this.props.subTaskInstance.SubTask.TaskItems.map(
            (taskItem, index) => {
              switch (taskItem.TaskItemType) {
                case "Form":
                  return (
                    <TableCell key={index} scope="col" border="bottom">
                      <Box direction="row" alignContent="center">
                        <Clipboard></Clipboard>
                        <Text margin={{ left: "small" }}>
                          {taskItem.FormItems[0].Title}
                        </Text>
                      </Box>
                    </TableCell>
                  );

                case "Checklist":
                  return (
                    <TableCell key={index} scope="col" border="bottom">
                      <Box direction="row" alignContent="center">
                        <Compliance></Compliance>
                        <Text margin={{ left: "small" }}>
                          {taskItem.Checklists[0].Title}
                        </Text>
                      </Box>
                    </TableCell>
                  );

                case "Take Photo":
                  return (
                    <TableCell key={index} scope="col" border="bottom">
                      <Box direction="row" alignContent="center">
                        <Camera></Camera>
                        <Text margin={{ left: "small" }}>
                          {taskItem.TakePhotoTaskItems[0].Title}
                        </Text>
                      </Box>
                    </TableCell>
                  );
              }
            }
          )} */}
          Task Items:
        </TableHeader>
        <TableBody>
          <TableRow>
            <TaskItemContainer>
              {this.props.subTaskInstance.SubTask.TaskItems.map(
                (taskItem, index) => {
                  return (
                    <TaskItemNameValuePair
                      subTaskInstance={this.props.subTaskInstance}
                      takePhotoInstances={takePhotoInstances}
                      taskItem={taskItem}
                      key={index}
                    ></TaskItemNameValuePair>
                  );
                }
              )}
            </TaskItemContainer>
            {/* {this.props.subTaskInstance.SubTask.TaskItems.map(
              (taskItem, index) => {
                //console.log(taskItem);
                switch (taskItem.TaskItemType) {
                  case "Form":
                    //console.log("form", taskItem.FormItems[0]);
                    let text = "";

                    if (typeof taskItem.FormItems[0] === "object") {
                      const formItemId = taskItem.FormItems[0].Id;
                      this.props.subTaskInstance.FormItemInstances.forEach(
                        (formItemInstance) => {
                          // console.log(formItemInstance);
                          if (formItemInstance.FormItemId === formItemId) {
                            text = formItemInstance.Input;
                          }
                        }
                      );
                    }

                    return (
                      <TableCell key={index} scope="col" border="bottom">
                        {text}
                      </TableCell>
                    );

                  case "Checklist":
                    console.log("checklist task item", taskItem);
                    let completed;
                    if (
                      typeof taskItem.Checklists === "object" &&
                      taskItem.Checklists.length !== 0
                    ) {
                      const checklistId = taskItem.Checklists[0].Id;
                      this.props.subTaskInstance.ChecklistInstances.forEach(
                        (checklistInstance) => {
                          if (checklistInstance.Checklist.Id === checklistId) {
                            completed = checklistInstance.IsComplete;
                          }
                        }
                      );
                    }

                    let checklistText;
                    let checkIcon;
                    if (completed) {
                      checklistText = "Complete";
                      checkIcon = <FormCheckmark></FormCheckmark>;
                    } else {
                      checklistText = "Incomplete";
                      checkIcon = <FormClose></FormClose>;
                    }
                    return (
                      <TableCell key={index} scope="col" border="bottom">
                        <Box direction="row" alignContent="center">
                          {checkIcon}
                          <Text>{checklistText}</Text>
                        </Box>
                      </TableCell>
                    );

                  case "Take Photo":
                    //console.log("Take photo");
                    //console.log(taskItem);
                    let url;
                    const takePhotoId = taskItem.TakePhotoTaskItems[0].Id;

                    for (const takePhotoInstance of takePhotoInstances) {
                      if (
                        takePhotoInstance.TakePhotoTaskItemId === takePhotoId
                      ) {
                        url = takePhotoInstance.URL;
                      }
                    }

                    return (
                      <TableCell
                        key={index}
                        scope="col"
                        border="bottom"
                        alignContent="center"
                      >
                        <Box
                          height="180px"
                          width="180px"
                          alignContent="center"
                          margin={{ horizontal: "medium" }}
                        >
                          <img
                            height="200px"
                            width="200px"
                            object-fit="cover"
                            src={url}
                          />
                        </Box>
                      </TableCell>
                    );
                }
              }
            )} */}
          </TableRow>
        </TableBody>
      </Table>
    );
  }
}

export default TaskItemListRow;
